import { ReactElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { ServerStyleSheet } from 'styled-components';

import { SsrProps } from 'ssr/types/SsrProps';

import { ssrWrapInAmpTemplate } from './ssrWrapInAmpTemplate';

type Args = {
  element: ReactElement;
  ssrProps: SsrProps;
};

export function ssrServerAmp({ element, ssrProps }: Args) {
  const sheet = new ServerStyleSheet();

  const body = renderToStaticMarkup(sheet.collectStyles(element)).replace(
    /data-style/g,
    'style',
  );

  const styleTags = sheet
    .getStyleTags()
    .replace(/<\/?style[^>]*>/g, '')
    .replace(/@media screen and \(min-width:(576|768|992)px\){}/g, '')
    .replaceAll('!important', '');

  return ssrWrapInAmpTemplate({ ssrProps, styleTags, body });
}
